import type { BracketResponse } from '@shared-types/bracket.types';
import { loadFromAPIs } from '@utilities/fetch';
import { apiKey, bracketApiUrl } from '@utilities/WindowContext';

export const fetchBracket = (params: { competitionId: string; seasonYear: string }, signal?: AbortSignal) =>
  loadFromAPIs<BracketResponse>('v1/bracket', params, { apiKey, apiUrl: bracketApiUrl, signal });
